import type { PaginationLocales } from '@/types/lang/locales'

export const paginationEn: PaginationLocales = {
    line: 'line',
    lines: 'lines',
    total: 'Total'
}
